module.exports = __webpack_public_path__ + "static/media/pau_sax_timmy_bass.f3724069.jpg";